import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { authService, userService } from '../services/api'
import toast from 'react-hot-toast'

export const useAuth = () => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    checkAuth()
  }, [])

  const checkAuth = async () => {
    try {
      setLoading(true)
      
      // Verificar si hay token
      if (!authService.isAuthenticated()) {
        setIsAuthenticated(false)
        setUser(null)
        return
      }

      // Obtener perfil del usuario
      const response = await userService.getProfile()
      setUser(response.user)
      setIsAuthenticated(true)
    } catch (error) {
      console.error('Error al verificar autenticación:', error)
      // Si hay error, limpiar autenticación
      authService.logout()
      setIsAuthenticated(false)
      setUser(null)
    } finally {
      setLoading(false)
    }
  }

  const logout = () => {
    authService.logout()
    setIsAuthenticated(false)
    setUser(null)
    navigate('/login')
    toast.success('Sesión cerrada exitosamente')
  }

  return {
    user,
    loading,
    isAuthenticated,
    isAdmin: user?.role === 'admin',
    checkAuth,
    logout
  }
}

export const useRequireAuth = (requiredRole = null) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      try {
        setLoading(true)
        
        // Verificar si hay token
        if (!authService.isAuthenticated()) {
          toast.error('Debes iniciar sesión para acceder a esta página')
          navigate('/login')
          return
        }

        // Obtener perfil del usuario
        const response = await userService.getProfile()
        setUser(response.user)
        setIsAuthenticated(true)
        
        // Verificar rol si es requerido
        if (requiredRole && response.user?.role !== requiredRole) {
          toast.error('No tienes permisos para acceder a esta página')
          navigate('/')
          return
        }
      } catch (error) {
        console.error('Error al verificar autenticación:', error)
        // Si hay error, limpiar autenticación y redirigir
        authService.logout()
        toast.error('Debes iniciar sesión para acceder a esta página')
        navigate('/login')
      } finally {
        setLoading(false)
      }
    }

    checkAuthAndRedirect()
  }, [requiredRole, navigate])

  return { user, loading, isAuthenticated }
}